module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/loyalty-level-6-91bcd949d2bf9adb8ada26600faf0a4b.svg";